/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button, Typography} from '@mui/material';

export const ExpandableSection = styled(Box)(({theme}) => ({
  marginBottom: theme.spacing(3),
  marginTop: theme.spacing(6),
}));

export const ExpandButton = styled(Button)(({theme}) => ({
  justifyContent: 'flex-start',
  padding: theme.spacing(2, 4),
  textTransform: 'none',
  fontSize: '14px',
  fontWeight: 400,
  height: '56px',
  width: '200px',
  textAlign: 'left',
  borderRadius: '8px',
  background: '#4A4B4F',
  '&:hover': {
    backgroundColor: '#2D2E32',
  },
}));

export const ExpandableContent = styled(Box)(({theme}) => ({
  paddingTop: theme.spacing(2),
}));

export const TablesGrid = styled(Box)(({theme}) => ({
  display: 'flex',
  justifyContent: 'center',
  gap: theme.spacing(3),
}));

export const TableSection = styled(Box)(({theme}) => ({
  backgroundColor: theme.palette.background.default,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
}));

export const TableTitle = styled(Typography)(({theme}) => ({
  fontSize: '16px',
  fontWeight: 600,
  marginBottom: theme.spacing(2),
  color: theme.palette.text.primary,
}));

export const ExpandableHeaderContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'end',
  width: '100%',
}));

export const SelectContainer = styled(Box)(() => ({
  width: '250px',
  minWidth: '250px',
}));
